<template>

  <div class="bg-white text-gray-600 space-y-3 text-xs sm:text-sm lg:text-lg">

    <!-- LOGO Y DESCRIPCIÓN -->
    <div class="rounded-lg p-6 flex flex-col items-center text-center space-y-4">
      <div class="w-9/12 h-9/12 md:w-5/12 md:h-5/12 lg:w-2/12 lg:h-2/12 rounded-full overflow-hidden border border-gray-200 shadow-lg p-6 mb-2">
        <img :src="empresa.previewLogo" class="w-full h-full object-cover object-center" />
      </div>
      <div v-html="empresa.breveDescripcion" class="text-justify md:text-center"></div>
    </div>
    <!-- FIN LOGO Y DESCRIPCIÓN -->

    <!-- STAND -->
    <div class="border border-gray-200 shadow-lg rounded-lg p-4 gap-3" v-if="empresa.stand">
      <div class="text-lg md:text-xl text-center"><font-awesome-icon :icon="['fas', 'store']" /> STAND {{empresa.stand}}</div> 
    </div>
    <!-- FIN STAND -->

    <div class="flex flex-col lg:flex-row lg:gap-3">

      <!-- DOMICILIO -->
      <div class="flex flex-col lg:flex-row border border-gray-200 shadow-lg rounded-lg p-4 lg:gap-3 lg:w-1/2" v-if="empresa.direccion || empresa.localidad || empresa.provincia">
        <div class="w-full flex flex-row space-x-3">
          <div>
            <font-awesome-icon :icon="['fas', 'location-dot']" />
          </div>
          <div class="w-full flex flex-col">
            <span>{{ empresa.domicilio }}</span>
            <span>{{ empresa.localidad }}</span>
            <span>{{ empresa.provincia }}</span>
            <span>CP : {{ empresa.codigoPostal }}</span>
            <span>{{ empresa.pais.descripcion }}</span>
            <a :href="'tel:// ' + empresa.mailComercial">
              <font-awesome-icon :icon="['fas', 'phone']" class="mr-2" />{{ empresa.telefono }}
            </a>
            <a :href="googleMapsUrl"  target="_blank" class="text-blue-500 underline" v-if="googleMapsUrl">
              ¿Cómo llegar?
            </a>
          </div>
        </div>
      </div>
      <!-- FIN DOMICILIO -->
        
      <!-- CONTACTO -->
      <div class="flex flex-col border border-gray-200 shadow-lg rounded-lg p-4 gap-1 lg:w-1/2">
        <div class="w-full">
          <a :href="'mailto: ' + empresa.mailComercial">
            <font-awesome-icon :icon="['far', 'envelope']" class="mr-1" />{{ empresa.mailComercial }}
          </a>
        </div>
        <div  v-for="empresaRedSocial in empresa.empresaRedesSociales.filter(r => r.link)" v-bind:key="empresaRedSocial.id" :empresaRedSocial="empresaRedSocial">
          <div class="w-full">
            <font-awesome-icon :icon="empresaRedSocial.redSocial.icono.split(' ')" class="mr-1" />
            <a href="{{empresaRedSocial.link}}">{{empresaRedSocial.link}}</a>
          </div>
        </div>
      </div>
      <!-- FIN CONTACTO -->    
    </div>


    <div class="w-full grid grid-cols-1  gap-4" v-if="empresa.productos">
      <div  v-for="producto in empresa.productos" v-bind:key="producto.id" :producto="producto">
        <div class="grid grid-cols-1 lg:grid-cols-4 xl:grid-cols-5  border border-gray-200 shadow-lg rounded-lg p-4 gap-3 h-full">

          <div class="lg:col-span-1 w-full aspect-square overflow-hidden rounded-lg">
            <img :src="producto.previewFotoFile" class="w-full h-full object-cover object-center"/>            
          </div>
          
          <div class="lg:col-span-3 xl:col-span-4 flex flex-col text-justify ">
            <div class="text-2xl">{{producto.descripcion}}</div>
            <div class="text-gray-600 mt-1">{{producto.detalles}}</div>

            
          </div>

        </div>
      </div>
    </div>

    <!-- TAGS -->
    <div class="flex flex-col border border-gray-200 shadow-lg rounded-lg p-4 gap-1">
      <div v-for="[tagId, { tag, tagOpciones }] in tags" :key="tagId">
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2">
            <label class="block mb-1 text-xs">{{ tag.descripcion }}</label>
            <div class="flex flex-wrap gap-2">
              <span v-for="tagOpcion in tagOpciones" :key="tagOpcion.id" class="px-3 py-1 bg-gray-200 rounded-lg">
                {{ tagOpcion.descripcion }}
              </span>
            </div>
          </div>
        </div>
      </div>      
    </div>
    <!-- FIN TAGS -->

    <a @click="closeDialog()" class="py-3 mt-2 block rounded-lg border border-black bg-transparent text-black hover:bg-black hover:text-white cursor-pointer text-center">
      <font-awesome-icon :icon="['fas', 'xmark']" /> CERRAR
    </a>


  </div>
  
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { Empresa, Tag, TagOpcion } from 'qreventos-suite/src/services/suite.interfaces';

export default defineComponent({  
  props: {
    empresa: {
      type: {} as PropType<Empresa>,
      required: true
    },
    closeFunction: {
      type: Function,
      required: false
    }
  },
  methods: {
    closeDialog() {
      if(this.closeFunction) {
        this.closeFunction();
      }
    }
  },
  computed: {
    googleMapsUrl() {
      let direccion:string = this.empresa.domicilio? this.empresa.domicilio: '';
      direccion += this.empresa.localidad? ', ' + this.empresa.localidad : '';
      direccion += this.empresa.provincia? ', ' + this.empresa.provincia: '';
      direccion += this.empresa.pais && this.empresa.pais.descripcion? ', ' + this.empresa.pais.descripcion : '';
      return direccion ? `https://www.google.com/maps/search/?q=${encodeURIComponent(direccion)}`: '';
    }
  },  
  data() {
    return {
      isSubmitting: false,
      tags: {} as Map<number, { tag: Tag; tagOpciones: TagOpcion[] }>
    };
  },  
  mounted() {
    this.tags = this.empresa.empresaTags.reduce((acc, empresaTag) => {
      const tagId = empresaTag.tag.id;

      if (!acc.has(tagId)) {
        acc.set(tagId, { tag: empresaTag.tag, tagOpciones: [] });
      }

      acc.get(tagId)?.tagOpciones.push(empresaTag.tagOpcion);
        return acc;
      }, new Map<number, { tag: Tag; tagOpciones: TagOpcion[] }>());
  }
});
</script>
